var _ThemeServiceInit_instances, _ThemeServiceInit_theme, _ThemeServiceInit_storage, _ThemeServiceInit_refresh, _ThemeServiceInit_getColorEntries;
import { __classPrivateFieldGet } from "tslib";
import { get, writable } from 'svelte/store';
import { LocalStorageManager } from '../model/storage/LocalStorageManager';
import { ColorSet } from '../model/theme/ColorSet';
class ThemeServiceInit {
    constructor() {
        _ThemeServiceInit_instances.add(this);
        _ThemeServiceInit_theme.set(this, writable('default'));
        _ThemeServiceInit_storage.set(this, new LocalStorageManager());
        __classPrivateFieldGet(this, _ThemeServiceInit_theme, "f").set(__classPrivateFieldGet(this, _ThemeServiceInit_storage, "f").isDarkMode ? 'dark' : 'default');
        __classPrivateFieldGet(this, _ThemeServiceInit_instances, "m", _ThemeServiceInit_refresh).call(this);
    }
    get theme() {
        return __classPrivateFieldGet(this, _ThemeServiceInit_theme, "f");
    }
    setTheme(theme) {
        __classPrivateFieldGet(this, _ThemeServiceInit_theme, "f").set(theme);
        __classPrivateFieldGet(this, _ThemeServiceInit_storage, "f").isDarkMode = theme === 'dark';
        __classPrivateFieldGet(this, _ThemeServiceInit_instances, "m", _ThemeServiceInit_refresh).call(this);
    }
}
_ThemeServiceInit_theme = new WeakMap(), _ThemeServiceInit_storage = new WeakMap(), _ThemeServiceInit_instances = new WeakSet(), _ThemeServiceInit_refresh = function _ThemeServiceInit_refresh() {
    const colorEntries = Object.entries(__classPrivateFieldGet(this, _ThemeServiceInit_instances, "m", _ThemeServiceInit_getColorEntries).call(this));
    const css = colorEntries
        .map(([key, value]) => {
        const newKey = key.replace(/[A-Z]/g, (value) => `-${value.toLowerCase()}`);
        return `--${newKey}:${value}`;
    })
        .join(';');
    document.documentElement.style.cssText = css;
}, _ThemeServiceInit_getColorEntries = function _ThemeServiceInit_getColorEntries() {
    switch (get(__classPrivateFieldGet(this, _ThemeServiceInit_theme, "f"))) {
        case 'dark':
            return ColorSet.DarkTheme;
        case 'default':
        default:
            return ColorSet.DefaultTheme;
    }
};
export const ThemeService = new ThemeServiceInit();
